<template>
    <div>
        <h3 class="mb-3">Opened  sessions per channel </h3>
        <div class="no-data-placeholder" v-if="!this.channels.length">
            <img class="w-h-35 vertical-align-middle" src="../../assets/img/box.svg">
            <span class="vertical-align-middle mx-2 italic">
                No available results for this time period
            </span>
        </div>
        <apex-chart  :options="options" :series="series" :height="400"></apex-chart>
    </div>
</template>

<script>
    import apexChart from 'vue-apexcharts'
    export default {
        name: "sessions",
        components: {
            apexChart
        },
        props: {
            channels: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data () {
            return {
                options: {
                    chart: {
                        id: 'session-date',
                        height: 300,
                        width: 400,
                    },
                    markers: {
                        size: 5,
                        colors: undefined,
                        strokeColors: '#fff',
                        strokeWidth: 2,
                        strokeOpacity: 0.9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        discrete: [],
                        shape: "circle",
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: undefined,
                        onDblClick: undefined,
                        hover: {
                            size: undefined,
                            sizeOffset: 3
                        }
                    },
                    stroke: {
                        width: [4, 4, 4]
                    },
                    xaxis: {
                        type: 'datetime',
                        title:{
                            text: ' '
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Session / Day'
                        }
                    }
                },
                series: [

                ]
            }
        },
        mounted (){

        },
        methods: {

        },
        watch: {
            channels () {
                this.series = []
                for (let j = 0; j < this.channels.length; j++) {
                    let name = this.channels[j].name
                    let data = []
                    for (let i = 0; i < this.channels[j].data.sessions.count_per_date.length; i++) {
                        data.push({
                            x: this.channels[j].data.sessions.count_per_date[i].date,
                            y: this.channels[j].data.sessions.count_per_date[i].count
                        })
                    }
                    this.series.push({
                        name: name,
                        data: data,
                        type: 'line'
                    })
                }
            }
        }
    }
</script>

<style >
    .apexcharts-yaxis-label , .apexcharts-xaxis-label  {
        stroke: #333;
    }
</style>